export const LogoMark = ({ className = "", size = "h-16 w-16" }) => (
  <img
    src="/logo.png"
    alt="Sunrise Mart"
    data-testid="logo-watermark"
    className={`${size} rounded-xl object-cover bg-black shadow-lg ring-1 ring-white/10 ${className}`}
  />
);

export default LogoMark;
